import { useState } from "react";
import { Menu, X } from "lucide-react";

export function Header() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="flex justify-between items-center py-4 mb-16 relative">
      <div className="flex items-center">
        <a href="/">
          <img
            src="/logo.png"
            alt="My Football Game Logo"
            className="w-16 h-16 object-contain mr-3"
          />
        </a>
      </div>

      <nav>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden text-[var(--accent)]"
        >
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>

        <ul
          className={`flex flex-col md:flex-row text-[var(--accent)] md:space-x-8 absolute md:static top-16 right-0 bg-[var(--surface-1)] md:bg-transparent w-full md:w-auto p-6 md:p-4 shadow md:shadow-none transition-all duration-300 ${
            isOpen ? "block" : "hidden md:flex"
          }`}
        >
          {[
            { href: "#features", label: "Features" },
            { href: "/how-to-play", label: "How to Play" },
            { href: "/blog", label: "Blog" },
            { href: "/leaderboard", label: "Leaderboard" },
            { href: "/faq", label: "FAQ" },
            { href: "/about", label: "About" },
          ].map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className="block py-2 md:py-0 hover:text-[var(--accent)] transition-colors"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
}
